<template>
    <div class="tabs__panel" v-show="active" :aria-hidden="!active">
        <slot/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class Tab extends Vue {
        @Prop({type: String, required: true})
        name;

        @Prop({type: Boolean, default: true})
        enabled;

        active = false;
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Tab.vue